import React, { FC } from 'react';
import classNames from 'classnames';

import styles from './Spinner.module.scss';

export type SpinnerProps = {
  size?: number;
  className?: string;
};

export const Spinner: FC<SpinnerProps> = ({ size = 48, className }) => {
  const rootClassname = classNames(styles.root, className);
  return (
    <span className={rootClassname}
          data-testid="spinner">
      <svg className={styles.indicator}
           data-test="spinner"
           width={size}
           height={size}
           viewBox="0 0 48 48"
           fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path className={styles.circle}
              d="M30.0865 45.1413C41.7625 41.7798 48.5028 29.5895 45.1413 17.9135C41.7798 6.23749 29.5896 -0.502796 17.9135 2.85867C6.2375 6.22013 -0.50278 18.4104 2.85868 30.0864C6.22014 41.7625 18.4104 48.5027 30.0865 45.1413Z"
              strokeWidth="3"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round" />
        <path className={styles.circuit}
              d="M17.9136 2.85864C29.5896 -0.502819 41.7799 6.23747 45.1414 17.9135"
              strokeWidth="3"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round" />
      </svg>
    </span>
  );
};
